import { render, staticRenderFns } from "./FhSwitchCategoria.vue?vue&type=template&id=5e93e66c&scoped=true&"
import script from "./FhSwitchCategoria.vue?vue&type=script&lang=js&"
export * from "./FhSwitchCategoria.vue?vue&type=script&lang=js&"
import style0 from "./FhSwitchCategoria.vue?vue&type=style&index=0&id=5e93e66c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e93e66c",
  null
  
)

export default component.exports